module.exports = __webpack_public_path__ + "assets/media/lunch.c6ee8dde.mp3";